
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getScenarios",
      resolverType: "query",
      routePath: "/getScenarios",
      httpMethod: "POST",
    });
  